import { DatePipe } from "@angular/common";
import {
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import {
    NgbAccordionBody,
    NgbAccordionButton,
    NgbAccordionCollapse,
    NgbAccordionDirective,
    NgbAccordionHeader,
    NgbAccordionItem,
    NgbAccordionToggle,
    NgbCollapse
} from "@ng-bootstrap/ng-bootstrap";
import { TranslateDirective, TranslatePipe } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { FilterPipe } from "../../pipes/filter.pipe";
import { HighlightPipe } from "../../pipes/highlight.pipe";
import { ApiClientService } from "../../services/api-client.service";
import { IHandelseLogg } from "./data-change-log.models";

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: "rask-data-change-log",
    styleUrls: ["./data-change-log.component.scss"],
    templateUrl: "./data-change-log.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateDirective,
        FormsModule,
        NgbAccordionDirective,
        NgbAccordionItem,
        NgbAccordionHeader,
        NgbAccordionToggle,
        NgbAccordionButton,
        NgbCollapse,
        NgbAccordionCollapse,
        NgbAccordionBody,
        DatePipe,
        TranslatePipe,
        HighlightPipe,
        FilterPipe
    ]
})
export class DataChangeLogComponent implements OnInit {
    logData: IHandelseLogg[];
    loggFilter: string;
    @Input() referenceId: number;
    @Input() table: string;

    private readonly apiClient = inject(ApiClientService);

    getHandelseLogg(tabell: string, refId: number): Observable<IHandelseLogg[]> {
        return this.apiClient.post<any, IHandelseLogg[]>(`Loggning/GetHandelseLogg/`, { tabell: tabell,
            ref_id: refId }, true);
    }

    ngOnInit() {
        this.getHandelseLogg(this.table, this.referenceId).subscribe(r => this.logData = r);
    }
}
